import { Input } from "components/Input";
import { Body, Header, TableContent } from "components/Table/style";
import { Col, Row } from "styles";

export function CallusAndChest({ checklist, setChecklist }) {
  return (
    <>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            params="callusAndChest.accommodationDensity.summer"
            type="select"
            label="Densidade no alojamento (Verão)"
            placeholder="Selecione uma Opção"
            options={[
              { value: "50" },
              { value: "45" },
              { value: "40" },
              { value: "35" },
            ]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            params="callusAndChest.accommodationDensity.winter"
            type="select"
            label="Densidade no alojamento (Inverno)"
            placeholder="Selecione uma Opção"
            options={[
              { value: "60" },
              { value: "55" },
              { value: "50" },
              { value: "45" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.pinteiro"
            label="Pinteiro forrato c/papel"
            placeholder="Selecione uma Opção"
            options={[{ value: "Sim" }, { value: "Não" }]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.farmType"
            label="Tipo de granja "
            placeholder="Selecione uma Opção"
            options={[
              { value: "Convencional" },
              { value: "Climatizada" },
              { value: "Dark House" },
            ]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.density"
            label="Densidade"
            placeholder="Selecione uma Opção"
            options={[
              { value: "18" },
              { value: "16" },
              { value: "15" },
              { value: "14" },
              { value: "12" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.kgM2"
            label="Kg /m2"
            placeholder="Selecione uma Opção"
            options={[
              { value: "50" },
              { value: "48" },
              { value: "45" },
              { value: "39" },
              { value: "35" },
            ]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="input"
            params="callusAndChest.averageWeight"
            label="Peso médio de saida"
            placeholder="Digite o peso médio"
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.space"
            label="Espaço"
            placeholder="Selecione uma Opção"
            options={[
              { value: "21(100%)" },
              { value: "18(100%)" },
              { value: "14(100%)" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.badHeight"
            label="Altura da Cama"
            placeholder="Selecione uma Opção"
            options={[
              { value: "20" },
              { value: "15" },
              { value: "10" },
              { value: "8" },
              { value: "5" },
            ]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.bedType"
            label="Tipo de Cama"
            placeholder="Selecione uma Opção"
            options={[
              { value: "C. amendoim" },
              { value: "C. arroz moida" },
              { value: "Casca de arroz" },
              { value: "Pó de elcalipto" },
              { value: "Pó de pinnus" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <TableContent>
            <Header>
              <tr>
                <th colspan="5">Aves c/ calo (Planilha campo)</th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Score</td>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
              </tr>
              <tr>
                <td>%</td>
                <td>
                  <Input
                    item={checklist}
                    setItem={setChecklist}
                    type="inputOnly"
                    params="callusAndChest.callus.0"
                  />
                </td>
                <td>
                  <Input
                    item={checklist}
                    setItem={setChecklist}
                    type="inputOnly"
                    params="callusAndChest.callus.1"
                  />
                </td>
                <td>
                  <Input
                    item={checklist}
                    setItem={setChecklist}
                    type="inputOnly"
                    params="callusAndChest.callus.2"
                  />
                </td>
                <td>
                  <Input
                    item={checklist}
                    setItem={setChecklist}
                    type="inputOnly"
                    params="callusAndChest.callus.3"
                  />
                </td>
              </tr>
            </Body>
          </TableContent>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.createdNumberBad"
            label="Número de criadas cama"
            placeholder="Selecione uma Opção"
            options={[
              { value: "2" },
              { value: "3" },
              { value: "4" },
              { value: "5" },
              { value: "6" },
            ]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.bedFermentationProcess"
            label="Processo de fermentação cama"
            placeholder="Selecione uma Opção"
            options={[{ value: "Sim" }, { value: "Não" }]}
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="select"
            params="callusAndChest.qualityBedWeek"
            label="Qualidade da cama semanal"
            placeholder="Selecione uma Opção"
            options={[
              { value: "7" },
              { value: "14" },
              { value: "21" },
              { value: "28" },
              { value: "35" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="input"
            params="callusAndChest.averageWeight"
            label="Umidade relativa"
            placeholder="Digite a Umidade relativa"
          />
        </Col>
        <Col>
          <Input
            item={checklist}
            setItem={setChecklist}
            type="input"
            params="callusAndChest.averageWeight"
            label="Cal"
          />
        </Col>
      </Row>
    </>
  );
}
